// extracted by mini-css-extract-plugin
var _1 = "WithdrawFormStyle-module__blocked___XIipo";
var _2 = "WithdrawFormStyle-module__withdrawForm___aWxlG";
export { _1 as "blocked", _2 as "withdrawForm" }
